import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {leadgen_template} from "../components/templates/leadgen_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class leadgen extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected leadgen_template: leadgen_template;
    protected googleFilterOptionsDirty: boolean = true;
    protected googleFilterOptionsKey: string = null;

    protected getModuleName(){

        return "leadgen";
    }

    buildContent() : Array<Element>{

        this.leadgen_template = new leadgen_template( "leadgen", this.viewModel, this );
        this.template = this.leadgen_template;

        return [this.leadgen_template.build()];
    }

    public fillPage() : void{

        this.leadgen_template.buildDatePickerCalendar();

        // First get the presets
        this.getSearchPresetsListData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/leadgen/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.leadgen_template.updateProductOptionsFromVerticals();
                obj.leadgen_template.updateCampaignOptionsFromBrands();
                obj.getListData();
            });
        };
    }

    protected updateFilters(responseParsed: any){

        this.leadgen_template.setBrandFilterItems(responseParsed.departments);
        this.leadgen_template.setVerticalFilterItems(responseParsed.vertical);
        this.leadgen_template.setProductOptionsByVertical(responseParsed.productByVertical);
        this.leadgen_template.setPartnerFilterItems(responseParsed.partner);
        if (responseParsed.campaign !== undefined) {
            this.leadgen_template.setCampaignFilterItems(responseParsed.campaign);
        }
        if (responseParsed.campaignLabel !== undefined) {
            this.leadgen_template.setCampaignLabelFilterItems(responseParsed.campaignLabel);
        }
        if (responseParsed.adGroup !== undefined) {
            this.leadgen_template.setAdGroupFilterItems(responseParsed.adGroup);
        }
        this.leadgen_template.setFormVariantFilterItems(responseParsed.formVariant);
        this.leadgen_template.setMilitaryAffiliationFilterItems(responseParsed.militaryAffiliation);
        this.leadgen_template.setStateFilterItems(responseParsed.state);
        this.leadgen_template.setDistributionChannelFilterItems(responseParsed.distributionChannel);
        this.leadgen_template.setTrafficSourceFilterItems(responseParsed.trafficSource);
        this.leadgen_template.setLeadBuyerFilterItems(responseParsed.leadBuyer);
        this.leadgen_template.setFormFilterItems(responseParsed.form);
        this.leadgen_template.setVersionFilterItems(responseParsed.version);
        this.leadgen_template.setDeviceOptionsFilterItems(responseParsed.device);
        this.leadgen_template.setDisplayModeFilterItems(responseParsed.displayMode);
    }

    public getListData(): void{


        this.loadingIn(this.leadgen_template.builtTemplate.children.namedItem("list-results"));
        let subViewModel = this.leadgen_template.getViewModelForRequest();
        let googleFilterOptionsKey = this.getGoogleFilterOptionsKey(subViewModel);
        if (this.googleFilterOptionsKey !== googleFilterOptionsKey) {
            this.googleFilterOptionsDirty = true;
            this.googleFilterOptionsKey = googleFilterOptionsKey;
        }
        subViewModel["googleFilterOptionsDirty"] = this.googleFilterOptionsDirty;
        let baseApiUrl = '/api/leadgen/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected getGoogleFilterOptionsKey(requestData: any): string {

        const normalizeArray = (items: any = []) => {
            let values = Array.isArray(items) ? items : [items];
            return (values || [])
                .map((item) => typeof item === "object" ? item.id : item)
                .filter((item) => item !== undefined && item !== null)
                .sort();
        };

        return JSON.stringify({
            selectedBrands: normalizeArray(requestData.selectedBrands),
            dateStart: requestData.dateStart,
            dateEnd: requestData.dateEnd,
            vertical: normalizeArray(requestData.vertical),
            product: normalizeArray(requestData.product),
        });
    }

    protected filterMultipleSelectorOnChange(filterId?: string){

        if (filterId === "verticalFilter" || filterId === "productFilter") {
            this.googleFilterOptionsDirty = true;
        }

        if (filterId === "verticalFilter"){

            this.leadgen_template.updateProductOptionsFromVerticals();
        }

        if (filterId === "verticalFilter" || filterId === "productFilter"){

            this.leadgen_template.updateCampaignOptions();
        }

        this.getListData();
    }

    protected filterDateOnChange(){

        this.googleFilterOptionsDirty = true;
        this.getListData();
    }

    public filterBrandSelectorOnChange(){

        this.googleFilterOptionsDirty = true;
        this.getListData();
    }

    protected filterSimpleOnChange(){

        this.getListData();
    }

    public filterDropdownOnChange(){

        this.getListData();
    }

    public listReorder(){

        this.getListData();
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let response = JSON.parse(req.request.response);
                obj.leadgen_template.resetSelectedRows();
                obj.leadgen_template.validationsList.clearMessages();
                obj.updateList(response);

            });
            
            if(req.request.readyState == 4 && req.request.status !== 0){

                // LOADING : ends
                obj.loadingOut(obj.leadgen_template.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

    protected updateList(data) {

        this.leadgen_template.setHeaders(data.headers);
        this.leadgen_template.setLeadgenData(data.leadgenData);
        this.leadgen_template.setBrandFilterItems(data.departments);
        if (data.campaign !== undefined) {
            this.leadgen_template.setCampaignFilterItems(data.campaign);
            this.googleFilterOptionsDirty = false;
        }
        if (data.campaignLabel !== undefined) {
            this.leadgen_template.setCampaignLabelFilterItems(data.campaignLabel);
        }
        if (data.adGroup !== undefined) {
            this.leadgen_template.setAdGroupFilterItems(data.adGroup);
        }
        this.leadgen_template.setFormVariantFilterItems(data.formVariant);
        this.leadgen_template.setStateFilterItems(data.state);
        this.leadgen_template.setLeadBuyerFilterItems(data.leadBuyer);
        this.leadgen_template.setDistributionChannelFilterItems(data.distributionChannel);
        if (this.leadgen_template.getViewModelForRequest().version !== "new") {
            this.leadgen_template.renderLeadgenChart('leadgen-revenue-chart', 'total_revenue');
            this.leadgen_template.renderLeadgenChart('leadgen-spend-chart', 'total_spend');
        }
        
    }
    public getListDataForCSV(): void{
    
        this.loadingIn(this.leadgen_template.builtTemplate.children.namedItem("list-results"));

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.leadgen_template.getViewModelForRequest();
        subViewModel["googleFilterOptionsDirty"] = false;
        subViewModel["export"] = true;

        let usrReq_url: string = '/api/leadgen/get';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onCSVDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onCSVDataRequestReturn(req, obj){

    return function (){
            
            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.leadgen_template.validationsList.clearMessages();
                obj.leadgen_template.setCsvExportData(responseParsed);
                obj.leadgen_template.exportCsvData();
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.leadgen_template.builtTemplate.children.namedItem("list-results"));
            }
        };
    }
}



// WEBPACK FOOTER //
// ./js/modules/leadgen.ts